import { cn } from "@utils/tailwind.util";

interface IBounceBarProps {
  className?: string;
}

export function BounceBar({ className }: IBounceBarProps) {
  return (
    <div
      className={cn(
        "relative w-full overflow-hidden rounded bg-gray-200 dark:gray-500 h-[5px]",
        className
      )}
    >
      <div className="absolute h-full w-1/3 bg-gradient-to-r from-transparent via-teal-500/50 to-transparent animate-bounce-bar" />
    </div>
  );
}
